import { ClientConfig } from 'client/configuration';
import { featureFlags as featureFlagsUtil } from 'client/utils/feature-flags';
import { DERIVED_EVENT_PARAMETERS, getPayloadStateSnapshot, updatePayloadState } from './parameter-sources';
import { matchesServerSidePayloadTrigger } from './triggers';

export function isServerSidePayloadEventsEnabled() {
  const gtmConfig = ClientConfig.get('gtm').default;

  return !!featureFlagsUtil.get()?.enableServerSidePayloadEvents && !!gtmConfig.serverSideContainer;
}

function isEmptyPayloadValue(value) {
  return value === undefined || value === null || value === '';
}

function getDerivedParameters(state) {
  const derivedParameters = {};

  Object.entries(DERIVED_EVENT_PARAMETERS).forEach(([key, resolveValue]) => {
    const value = resolveValue(state);

    Object.assign(derivedParameters, isEmptyPayloadValue(value) ? {} : { [key]: value });
  });

  return derivedParameters;
}

function getEventParameters(state) {
  return {
    ...state,
    ...getDerivedParameters(state),
  };
}

function buildServerSidePayload(runtimeParameters = {}, state) {
  return JSON.stringify({
    ...state,
    ...runtimeParameters,
  });
}

function sendPayloadIfTriggered(runtimeParameters, state) {
  const eventParameters = getEventParameters(state);

  if (!matchesServerSidePayloadTrigger(eventParameters)) {
    return;
  }

  const containerUrl = ClientConfig.get('gtm').default.serverSideContainer;
  const payload = new Blob([buildServerSidePayload(runtimeParameters, eventParameters)], { type: 'application/json' });

  navigator.sendBeacon(`${containerUrl}/venom`, payload);
}

function trackAndSendPayload(eventPayload, eventName) {
  const containerId = ClientConfig.get('gtm').default.id;
  const snapshot = getPayloadStateSnapshot();
  const pushObject = {
    ...eventPayload,
    eventCallback: id => {
      if (id !== containerId) return;

      const uniqueId = pushObject['gtm.uniqueEventId'];
      const start = window.google_tag_manager?.[containerId]?.dataLayer?.get('gtm.start');
      const eventUuid = `${uniqueId}_${start || snapshot.ts}`;

      sendPayloadIfTriggered({ event_uuid: eventUuid, event_name: eventName }, snapshot);
    },
  };

  window.dataLayer.push(pushObject);
}

export function processServerSidePayloadEvent(dataLayerItem, venomEnv) {
  updatePayloadState(dataLayerItem);

  if (dataLayerItem.event_type) {
    const eventName = venomEnv === 'sandbox' ? `${dataLayerItem.event_type}_vsandbox` : `${dataLayerItem.event_type}_v`;

    trackAndSendPayload(dataLayerItem, eventName);
  } else {
    window.dataLayer.push(dataLayerItem);
  }
}
